export type QuoteLanguageMode = "en_zh" | "en_only" | "zh_only";

const STATUS_LABELS: Record<string, [string, string]> = {
  normal: ["Normal", "正常"],
  included: ["Included", "已包含"],
  in_package: ["In Package", "打包内"],
  optional: ["Optional", "可选"],
  tbc: ["TBC", "待确认"],
  actual_cost: ["Actual Cost", "实报实销"],
  hidden: ["Hidden", "隐藏"],
};

const UNIT_LABELS: Record<string, [string, string]> = {
  day: ["Day", "天"],
  package: ["Package", "项"],
  item: ["Item", "项"],
  hour: ["Hour", "小时"],
  person: ["Person", "人"],
  set: ["Set", "套"],
  episode: ["Episode", "集"],
  minute: ["Minute", "分钟"],
  shot: ["Shot", "镜头"],
  frame: ["Frame", "张"],
  second: ["Second", "秒"],
};

export function createQuoteLanguage(mode: QuoteLanguageMode) {
  const pair = (english: string | null | undefined, chinese: string | null | undefined): string => {
    const en = english?.trim() ?? "";
    const zh = chinese?.trim() ?? "";

    if (mode === "en_only") return en || zh;
    if (mode === "zh_only") return zh || en;
    return [en, zh].filter(Boolean).join(" / ");
  };

  return {
    mode,
    pair,
    multiline: (english: string | null | undefined, chinese: string | null | undefined) => {
      const text = pair(english, chinese);
      return mode === "en_zh" ? text.replace(" / ", "<br />") : text;
    },
    status: (status: string) => {
      const labels = STATUS_LABELS[status];
      return labels ? pair(labels[0], labels[1]) : status;
    },
    unit: (unit: string) => {
      const labels = UNIT_LABELS[unit.trim().toLowerCase()];
      return labels ? pair(labels[0], labels[1]) : unit;
    },
  };
}
